import { render, staticRenderFns } from "./Retours.vue?vue&type=template&id=686e811f&scoped=true&lang=true&"
import script from "./Retours.vue?vue&type=script&lang=js&"
export * from "./Retours.vue?vue&type=script&lang=js&"
import style0 from "./Retours.vue?vue&type=style&index=0&id=686e811f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686e811f",
  null
  
)

export default component.exports